"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var ATLAtomAvatar_1 = require("../atoms/ATLAtomAvatar");
var ATLAtomLabel_1 = require("../atoms/ATLAtomLabel");
var ATLAtomLine_1 = require("../atoms/ATLAtomLine");
var ATLAtomIconButton_1 = require("../atoms/ATLAtomIconButton");
var defaultProps = {
    hideDivider: false,
    isNew: false,
    avatarBaseProps: {},
    dividerBaseProps: {},
    overflowIconButtonBaseProps: {},
    notificationLabelBaseProps: {},
    timestampLabelBaseProps: {}
};
// ASSETS --------------------------------------------------------------------------------------------------------------
var overflowVertical = require('../assets/ic_overflow_vert.png');
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.NotificationContainer = native_1.default(react_native_1.TouchableOpacity)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: row;\n  background-color: ", ";\n\tpadding:  ", "px \n            ", "px 0\n            ", "px;\n"], ["\n  flex-direction: row;\n  background-color: ", ";\n\tpadding:  ", "px \n            ", "px 0\n            ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.isNew ? atlTheme.ColorBackground : atlTheme.ColorNone;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingMarginal;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingMarginal;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingMarginal;
});
exports.AvatarWrapper = native_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin: 0 ", "px 0 0;\n"], ["\n\tmargin: 0 ", "px 0 0;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingMarginal;
});
exports.OverflowWrapper = native_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin: 0 0 0 ", "px;\n"], ["\n\tmargin: 0 0 0 ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalPadding || atlTheme.SpacingBase;
});
exports.TextWrapper = native_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: 1;\n  justify-content: center;\n"], ["\n  flex: 1;\n  justify-content: center;\n"])));
exports.TimestampWrapper = native_1.default(react_native_1.View)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  justify-content: center;\n\tmargin: ", "px 0 0 0;\n"], ["\n  justify-content: center;\n\tmargin: ", "px 0 0 0;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalPadding || atlTheme.SpacingAtomic;
});
exports.DividerWrapper = native_1.default(react_native_1.View)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: ", "px 0 0 0;\n"], ["\n  margin: ", "px 0 0 0;\n"
    // Contains everything except for the avatar
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
});
// Contains everything except for the avatar
exports.RightContainer = native_1.default(react_native_1.View)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"
    // Contains everything except for the avatar and the divider
])));
// Contains everything except for the avatar and the divider
exports.RowContainer = native_1.default(react_native_1.View)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex-direction: row;\n  min-height: ", "px;\n"], ["\n  flex-direction: row;\n  min-height: ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.SizeAvatarMedium;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLNotificationListItem = function (_a) {
    var notificationText = _a.notificationText, placeholderImage = _a.placeholderImage, timestampText = _a.timestampText, typeIcon = _a.typeIcon, userAvatar = _a.userAvatar, onPressNotification = _a.onPressNotification, onPressOverflowButton = _a.onPressOverflowButton, onPressUser = _a.onPressUser, hideDivider = _a.hideDivider, isAvatarSquare = _a.isAvatarSquare, isNew = _a.isNew, horizontalMargin = _a.horizontalMargin, horizontalPadding = _a.horizontalPadding, verticalMargin = _a.verticalMargin, verticalPadding = _a.verticalPadding, avatarBaseProps = _a.avatarBaseProps, dividerBaseProps = _a.dividerBaseProps, overflowIconButtonBaseProps = _a.overflowIconButtonBaseProps, notificationLabelBaseProps = _a.notificationLabelBaseProps, timestampLabelBaseProps = _a.timestampLabelBaseProps;
    var theme = ThemeProvider_1.useTheme();
    // Renders Avatar
    var renderAvatar = function () {
        if (userAvatar) {
            return (react_1.default.createElement(exports.AvatarWrapper, { horizontalMargin: horizontalMargin },
                react_1.default.createElement(ATLAtomAvatar_1.ATLAtomAvatar, __assign({ source: userAvatar, placeholder: placeholderImage, avatarSize: theme.SizeAvatarMedium, borderColor: theme.ColorBrand1Default, borderRadius: isAvatarSquare ? theme.BorderRadiusAvatarMediumSquare : theme.BorderRadiusAvatarMedium, borderWidth: theme.BorderWidthAvatar, icon: typeIcon, iconSize: theme.SizeIconBase, iconColor: theme.ColorBrand1Default }, avatarBaseProps))));
        }
    };
    // Renders notification text
    var renderNotificationText = function () { return (react_1.default.createElement(ATLAtomLabel_1.ATLAtomLabel, __assign({ fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeBody, fontWeight: theme.FontWeightNormal, lineHeight: theme.LineHeightBase, multilineLimit: theme.MultilineLimitBody, textColor: theme.ColorHighContrast }, notificationLabelBaseProps), notificationText)); };
    // Renders timestamp text
    var renderTimestamp = function () { return (react_1.default.createElement(exports.TimestampWrapper, { verticalPadding: verticalPadding },
        react_1.default.createElement(ATLAtomLabel_1.ATLAtomLabel, __assign({ fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeAuxiliary, fontWeight: theme.FontWeightStrong, lineHeight: theme.LineHeightBase, textColor: theme.ColorLowContrast }, timestampLabelBaseProps), timestampText))); };
    // Renders overflow button
    var renderOverflowButton = function () { return (react_1.default.createElement(exports.OverflowWrapper, { horizontalPadding: horizontalPadding },
        react_1.default.createElement(ATLAtomIconButton_1.ATLAtomIconButton, __assign({ icon: overflowVertical, onPress: onPressOverflowButton, buttonColor: theme.ColorNone, buttonSize: theme.HeightButtonBase, buttonBorderColor: theme.ColorNone, buttonBorderWidth: 0, iconColor: theme.ColorHighContrast, iconSize: theme.SizeIconBase }, overflowIconButtonBaseProps)))); };
    // Renders Divider
    var renderDivider = function () { return (react_1.default.createElement(exports.DividerWrapper, { verticalMargin: verticalMargin },
        react_1.default.createElement(ATLAtomLine_1.ATLAtomLine, __assign({ thickness: theme.HeightDivider, color: theme.ColorBackground }, dividerBaseProps)))); };
    // Returns complete ATLNotificationListItem
    return (react_1.default.createElement(exports.NotificationContainer, { onPress: onPressNotification, activeOpacity: 0.9, horizontalMargin: horizontalMargin, verticalMargin: verticalMargin, isNew: isNew },
        onPressUser ? react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: onPressUser }, renderAvatar()) : renderAvatar(),
        react_1.default.createElement(exports.RightContainer, null,
            react_1.default.createElement(exports.RowContainer, null,
                react_1.default.createElement(exports.TextWrapper, null,
                    renderNotificationText(),
                    renderTimestamp()),
                onPressOverflowButton && renderOverflowButton()),
            !hideDivider && renderDivider())));
};
exports.ATLNotificationListItem.defaultProps = defaultProps;
exports.ATLNotificationListItem.displayName = 'ATLNotificationListItem';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
